package com.anjuros.website.redesign.sections.home

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.RdSectionFlushTopStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.styles.RdStepsStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

private val LaterSteps = listOf(
    RdText.HOME_STEP2_TITLE to RdText.HOME_STEP2_TEXT,
    RdText.HOME_STEP3_TITLE to RdText.HOME_STEP3_TEXT,
    RdText.HOME_STEP4_TITLE to RdText.HOME_STEP4_TEXT,
)

/** Four numbered steps; the numbers come from a CSS counter in RdStepsStyle. */
@Composable
fun HomeHowItWorksSection() {
    RdSection(
        id = "how",
        labelledBy = "how-h",
        modifier = RdSectionStyle.toModifier().then(RdSectionFlushTopStyle.toModifier()),
    ) {
        RdSectionHead(RdText.HOME_HOW_EYEBROW, "how-h", RdText.HOME_HOW_TITLE)
        Ol(RdStepsStyle.toModifier().toAttrs()) {
            Li {
                H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(RdText.HOME_STEP1_TITLE)) }
                P {
                    Text(LocalText(RdText.HOME_STEP1_TEXT))
                    RdLink(RdRoute.DESIGNS) { Text(LocalText(RdText.HOME_STEP1_LINK)) }
                }
            }
            LaterSteps.forEach { (title, text) ->
                Li {
                    H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
                    P { Text(LocalText(text)) }
                }
            }
        }
    }
}
